import classNames from "classnames";

import { TableContextType, useTableContext } from "../context";
import Select from "../select";
import TableColumnHeaderWrapper from "./cell-wrapper";

interface TableHeadingProps {
  selectable: boolean;
}

function TableHeading({ selectable }: TableHeadingProps) {
  const { table } = useTableContext() as TableContextType;
  const headerGroups = table.getHeaderGroups();
  const allRowsChecked = table.getIsAllRowsSelected();
  const onAllRowsCheckedChange = table.getToggleAllRowsSelectedHandler();

  return (
    <thead className="bg-primary-50">
      {headerGroups.map((headerGroup) => (
        <tr key={headerGroup.id}>
          {selectable && (
            <th className={classNames("py-2 px-4 w-0")}>
              <Select
                checked={allRowsChecked}
                onChange={onAllRowsCheckedChange}
              />
            </th>
          )}
          {headerGroup.headers
            .filter((header) => header.column.getIsVisible())
            .map((header) => (
              <TableColumnHeaderWrapper key={header.id} header={header} />
            ))}
        </tr>
      ))}
    </thead>
  );
}

export default TableHeading;
